import { Card, Image } from "antd";
import { MobileOutlined } from "@ant-design/icons";
import "./css/inspiration-card-mobile.css";

const InspirationCardMobile = ({ item, onOpen }) => {
    return (
        <Card
            hoverable
            className="inspiration-mobile-list-card"
            bodyStyle={{ padding: 0, display: "flex", flexDirection: "column", height: "100%" }}
            onClick={() => onOpen(item)}
        >
            <div className="imlc-preview">
                <div className="imlc-preview-inner">
                    <div className="imlc-screen-frame">
                        <div className="imlc-screen">
                            <Image
                                src={item.projectFeatureImage}
                                preview={false}
                                className="imlc-image"
                            />
                        </div>
                    </div>
                </div>
                <div className="imlc-preview-badge" aria-hidden>
                    <MobileOutlined />
                    <span>Mobile</span>
                </div>
            </div>

            <div className="imlc-footer">
                {item.projectLogo ? (
                    <div className="imlc-logo">
                        <Image src={item.projectLogo} preview={false} />
                    </div>
                ) : (
                    <div className="imlc-logo imlc-logo--placeholder" aria-hidden>
                        {(item.projectTitle || "?").charAt(0).toUpperCase()}
                    </div>
                )}
                <div className="imlc-copy">
                    <div className="imlc-title">{item.projectTitle}</div>
                    <div className="imlc-meta">
                        {item?.category?.name ? (
                            <span className="imlc-cat">{item.category.name}</span>
                        ) : null}
                    </div>
                    {item.tagline ? <div className="imlc-tagline">{item.tagline}</div> : null}
                </div>
            </div>
        </Card>
    );
};

export default InspirationCardMobile;
